import React, { useState } from 'react';
import { auth } from '../firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { useNavigate, Link } from 'react-router-dom';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/profile');
    } catch (err) {
      setError('INVALID CREDENTIALS.');
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>IDENTIFY YOURSELF</h2>
        {error && <p style={styles.error}>{error}</p>}
        <form onSubmit={handleLogin} style={styles.form}>
          <input type="email" placeholder="EMAIL" onChange={(e) => setEmail(e.target.value)} style={styles.input} />
          <input type="password" placeholder="PASSWORD" onChange={(e) => setPassword(e.target.value)} style={styles.input} />

          {/* Visual confirmation of terms */}
          <div style={styles.termsBox}>
            <input type="checkbox" checked disabled style={styles.checkbox} />
            <span>I reaffirm my commitment to the <Link to="/terms" style={styles.link}>Terms</Link>.</span>
          </div>

          <button type="submit" style={styles.button}>ACCESS TERMINAL</button>
        </form>
        <p style={{ marginTop: '20px', color: '#666' }}>NO ID? <Link to="/signup" style={styles.link}>INITIATE HERE</Link></p>
      </div>
    </div>
  );
};

const styles = {
  container: { display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: '#000' },
  card: { background: '#111', padding: '40px', border: '1px solid #333', width: '100%', maxWidth: '400px', textAlign: 'center' },
  title: { fontFamily: 'Orbitron', color: '#D4AF37', marginBottom: '20px' },
  form: { display: 'flex', flexDirection: 'column', gap: '15px' },
  input: { padding: '15px', background: '#000', border: '1px solid #333', color: '#fff' },
  button: { padding: '15px', background: '#D4AF37', border: 'none', fontWeight: 'bold', cursor: 'pointer', fontFamily: 'Orbitron' },
  error: { color: 'red', fontSize: '0.9rem' },
  link: { color: '#D4AF37', textDecoration: 'none' },
  termsBox: { display: 'flex', gap: '10px', fontSize: '0.7rem', color: '#666', justifyContent: 'center' },
  checkbox: { accentColor: '#D4AF37' }
};

export default Login;
